import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, Effect } from '@ngrx/effects';


import * as asideItemactions from '../aside-item/aside-item.actions';


@Injectable()
export class AsideItemEffects {

    constructor(
        // private userService: UserService,
        private actions$: Actions
    ) { }

    

}
